export default "__VITE_ASSET__DGBIcnZT__"